const tooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  formatter: function() {
    return `
      <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
        <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
        <b>${this.key}</b></br>
        </div>
        <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
          <div style="color: ${this.color}; font-weight: bold">
            ${this.series.tooltipOptions.valuePrefix}${this.point.y.toFixed(2)} ${this.series.tooltipOptions.valueSuffix}</b>
          </div>
        </div>
      </div>
    `;
  },
  hideDelay: 100,
  shadow: false,
  shape: "square",
  style: { color: "black", padding: 0 },
  useHTML: true,
  valuePrefix: "$",
  valueSuffix: "million"
};

// options for the ODA charts
const chartOptions = {
  chart: {
    type: "bar",
    height: 300,
    width: 300,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  tooltip: tooltipOptions,
  xAxis: {
    tickLength: 0
  },
  yAxis: {
    min: 0,
    title: ""
  },
};

const odaTooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  formatter: function() {
    return `
      <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
        <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
        <b>${this.key}</b></br>
        </div>
        <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
          <div style="color: ${this.color}; font-weight: bold">
            ${this.series.tooltipOptions.valuePrefix}${this.point.y} ${this.series.tooltipOptions.valueSuffix}</b>
          </div>
        </div>
      </div>
    `;
  },
  hideDelay: 100,
  shadow: false,
  shape: "square",
  style: { color: "black", padding: 0, width: "225px" },
  useHTML: true,
  valuePrefix: "$",
  valueSuffix: "billion"
};

// the color of the bars on the ODA charts
const COLUMN_COLOR = "#3785b8";

// the max width for the bars on the tariff & ODA bar and column charts
const MAX_BAR_WIDTH = 40;

// the number of years to show on the 'Annual Total Disbursements' chart on the ODA tab
const NUM_OF_YEARS_TO_SHOW = 5;

// color scheme for 'Breakdown by donor' donut chart
const DONUT_COLORS = ["#C84646", "#B46D4F", "#549363", "#3384B7", "#843C81", "#F3B050", "#3A5352", "#78857F"];

export {
  tooltipOptions,
  chartOptions,
  odaTooltipOptions,
  COLUMN_COLOR, MAX_BAR_WIDTH,
  NUM_OF_YEARS_TO_SHOW,
  DONUT_COLORS
};
